<template>
  <v-app>
    <v-btn
      @click.stop="drawer = !drawer"
      v-show="$vuetify.breakpoint.xsOnly"
      icon
      color="success"
      style="    position: absolute;
    top: 10px;
    right: 10px;    z-index: 2;"
    >
      <v-icon small>fas fa-bars</v-icon>
    </v-btn>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list dense style="    font-size: 14px;">
        <template v-for="item in items">
          <v-list-item
            v-for="childrenitem in item.children"
            :key="childrenitem.cd"
            link
            @click="menuClick(childrenitem)"
            :to="isInternalLink(childrenitem.url) ? childrenitem.url : ''"
            class="no-deecoration pl-5"
            color="black"
            >{{ childrenitem.drawerText }}</v-list-item
          >
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-container>
      <v-layout>
        <v-content>
          <!-- <Header v-if="$route.path != '/signin'"></Header> -->
          <Header></Header>
          <router-view />
        </v-content>
        <v-footer
          app
          color="green lighten-2"
          style="font-size: 12px;"
          absolute
          padless
        >
          <v-row v-show="$route.path != '/signin'" class="ma-0"
            ><template v-for="item in $store.state.menuList">
              <v-col
                v-for="childrenitem in item.children"
                :key="childrenitem.cd"
                cols="6"
                sm="6"
                md="3"
              >
                <v-list-item
                  @click="menuClick(childrenitem)"
                  :to="isInternalLink(childrenitem.url) ? childrenitem.url : ''"
                  class="no-deecoration pl-5"
                  color="black"
                  >{{ childrenitem.drawerText }}</v-list-item
                ></v-col
              >
            </template>
          </v-row>
          <transition>
            <v-btn
              v-show="scrollPosition > 100"
              fixed
              dark
              fab
              bottom
              right
              small
              color="success"
              @click="scrollTop()"
            >
              <v-icon>fas fa-arrow-up</v-icon>
            </v-btn>
          </transition>
        </v-footer>
      </v-layout>
    </v-container>
  </v-app>
</template>
<script src="https://polyfill.io/v3/polyfill.min.js?features=es6"></script>
<script>
import store from "@/store";
import Header from "./components/Header";

export default {
  name: "App",
  components: {
    Header,
  },
  data: () => ({
    items: [],
    drawer: false,
    scrollPosition: 0,
  }),
  created() {
    let menu = this.$store.state.menuList;
    this.items = menu;
  },
  mounted() {
    document.onscroll = (e) => {
      this.scrollPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
    };
    var to = this.$route;
    this.createPageTitle(to);
  },
  watch: {
    $route(to, from) {
      this.createPageTitle(to);
    },
  },
  methods: {
    isInternalLink(url) {
      return !/^https?:\/\//.test(url);
    },
    menuClick(item) {
      const url = item.url;
      if (!this.isInternalLink(url)) {
        window.open(url, "_blank");
      }
    },
    scrollTop: function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    createPageTitle: function(to) {
      // タイトルを設定
      const pageTitle = to.meta.title ? " - " + to.meta.title : ""
      document.title = "点字サークル「杉」" + pageTitle + " | 埼玉県杉戸町の点字ボランティアサークル";

      // メタタグdescription設定
      const desc = to.meta.desc ? to.meta.desc : "点字サークル「杉」は埼玉県杉戸町の点字ボランティアサークルです。書籍の点訳などを行っており、100冊以上の点訳データを無料で公開しています。";
      document
        .querySelector("meta[name='description']")
        .setAttribute("content", desc);

      // メタタグrobots設定
      const index = to.meta.noindex ? "noindex" : "all";
      document
        .querySelector("meta[name='robots']")
        .setAttribute("content", index);
    },
  },
};
</script>

<style>
body pre {
  font-family: "Roboto", sans-serif;
}
.no-deecoration {
  text-decoration: none;
}
div >>> .v-list-item {
  padding: 0 !important;
}

/* スクロールボタン フェードイン */
.v-enter-active,
.v-leave-actibe {
  transition: opacity 1s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transition: opacity 1s;
}
</style>
